import { useIsFetching } from '@tanstack/react-query';
import cn from '@/utils/merge-class-names';

interface Props {
  className?: string;
}

export default function MessageStateIndicator({ className }: Props) {
  const isFetchingMessages = useIsFetching({
    predicate: ({ queryHash }) => !!queryHash.match(/GetChatData|GetGroupChatData/gi),
  });

  if (!isFetchingMessages) return null;

  return (
    <span className={cn('loading loading-spinner loading-sm m-2 text-base-content/50 opacity-20 size-4', className)} />
  );
}
